module.exports = __webpack_public_path__ + "img/1399754888.1fadf9cd.jpg";